<template>
  <span class="dmh-wrap">
    <b-button size="sm" variant="outline-secondary"
              title="How to use the Roster List" aria-label="Help" @click="show_help = true">
      <i class="fa fa-info-circle"></i>
    </b-button>

    <b-modal v-model="show_help" title="Using the Roster List" size="lg" ok-only scrollable>
      <div class="dmh-body">
        <h4>What this page is</h4>
        <p>
          Every driver, one row each, on the metrics that feed their combined score. The Dashboard
          shows you the shape of the fleet; this is the fleet itself, sortable.
        </p>

        <hr/>

        <h4>Finding people</h4>
        <ul>
          <li><b>Tier chips</b> filter to one band &mdash; the count on each chip is how many drivers are in it.</li>
          <li><b>Search</b> matches on driver name.</li>
          <li><b>Any column heading</b> sorts by that metric. Sorting by a KPI rather than the score is often the faster way to find who needs a conversation about one specific habit.</li>
        </ul>

        <hr/>

        <h4>Reading the colours</h4>
        <p>
          A metric is coloured against your tenant&rsquo;s thresholds, not against the rest of the
          roster &mdash; so a red cell means &ldquo;past the line you set&rdquo;, not &ldquo;worst
          on this page&rdquo;. Both boundaries and score weights live under <b>Settings</b> on the
          Dashboard.
        </p>
        <p>
          <b>Insufficient Data</b> drivers have too few miles or bus days this period to score
          fairly. They are listed, but not ranked &mdash; scoring them would mostly measure how
          little they drove.
        </p>

        <hr/>

        <h4>Getting it out</h4>
        <p>
          <b>Download All as CSV</b> exports every driver for the selected range with full
          precision, not the rounded figures shown here. It ignores the tier filter and the search
          box on purpose: an export is a record of the period, not of your current view.
        </p>

        <hr/>

        <h4>The date range</h4>
        <p>
          Scores are published in periods of about five days, each one five days after it ends,
          once your telematics provider's review window has closed. The range ends on the latest
          published period, so it never includes days that are still settling: a half-finished
          period would read as a drop in mileage. The <b>1m</b>, <b>3m</b>, <b>6m</b> and
          <b>12m</b> chips count back from there, and the date pickers show exactly the days being
          scored.
        </p>
      </div>
    </b-modal>
  </span>
</template>

<script>
export default {
  name: 'driver_manager_roster_list_help',
  data() {
    return { show_help: false }
  },
}
</script>

<style scoped>
.dmh-body h4 { font-size: 1.05rem; margin-top: 4px; }
.dmh-body p, .dmh-body li { font-size: 0.95rem; }
.dmh-body li { margin-bottom: 6px; }
</style>
